'use client';

import { IconButton, InputAdornment, TextField } from '@mui/material';
import { useState } from 'react';

import { EyeIcon } from '../../../atomic-atoms/icons';
import { TextInputProps } from '../types';

export function TextInput(
  props: TextInputProps & { type: 'text' | 'password' | 'textarea' },
) {
  const [showPassword, setShowPassword] = useState(false);
  const isTextarea = props.type === 'textarea';
  const isPassword = props.type === 'password';

  const isReadOnly = props?.readOnly ?? false;

  const inputType = isTextarea
    ? undefined
    : isPassword
      ? showPassword
        ? 'text'
        : 'password'
      : 'text';

  const passwordAdornment = isPassword ? (
    <InputAdornment position="end">
      <IconButton
        aria-label={showPassword ? 'Hide password' : 'Show password'}
        onClick={() => setShowPassword((prev) => !prev)}
        onMouseDown={(event) => event.preventDefault()}
        edge="end"
        size="small"
      >
        <EyeIcon
          open={showPassword}
          size={20}
          styles={{ color: 'var(--nn-color-input-icon)' }}
        />
      </IconButton>
    </InputAdornment>
  ) : undefined;

  const textFieldSlotProps = {
    input: {
      ...(passwordAdornment ? { endAdornment: passwordAdornment } : {}),
      readOnly: props.readOnly,
    },
  } as const;

  const textFieldSx = isTextarea
    ? {
        '& .MuiInputBase-inputMultiline': {
          resize: 'vertical',
        },
      }
    : undefined;

  return (
    <TextField
      fullWidth
      name={props.name}
      type={inputType}
      multiline={isTextarea}
      minRows={isTextarea ? props.minRows : undefined}
      maxRows={isTextarea ? props.maxRows : undefined}
      label={`${props.label}${isReadOnly ? ' (Read Only)' : ''}`}
      value={props.value}
      size={props.size}
      onChange={(e) => props.onChange(e.target.value)}
      onBlur={props.onBlur}
      onKeyDown={props.onKeyDown}
      autoFocus={props.autoFocus}
      error={!!props.error}
      helperText={props.error}
      slotProps={textFieldSlotProps}
      sx={textFieldSx}
    />
  );
}
